export default __webpack_public_path__ + "static/cm-delete-file-7066ff3e35b4c299578637978db13a8e.mp4";